export const fetchFacilitiesData = async () => {
    const facilitiesAPIBaseURL = global.config.facilitiesApiUrl;
    const facilitiesAPIURL = facilitiesAPIBaseURL + '/v1/facilities';
    const isRevenueParam = true;
    const facilitiesAPIURLWithBoolParam = `${facilitiesAPIURL}?isRevenue=${isRevenueParam.toString()}`;
    const rawResponse = await fetch(facilitiesAPIURLWithBoolParam);

    if (!rawResponse.ok) {
      throw new Error(rawResponse.statusText);
    }

    const rawFacilities = await rawResponse.json();

    return rawFacilities;
};

export const fetchNonRevAndRevFacilitiesData = async () => {
    const facilitiesAPIBaseURL = global.config.facilitiesApiUrl;
    const facilitiesAPIURL = facilitiesAPIBaseURL + '/v1/facilities';
    const rawResponse = await fetch(facilitiesAPIURL);

    if (!rawResponse.ok) {
        throw new Error(rawResponse.statusText);
    }

    const rawFacilities = await rawResponse.json();

    return rawFacilities;
}

export const fetchHolidayHoursData = async (airportCode) => {

  const facilitiesAPIBaseURL = global.config.facilitiesApiUrl;
  const facilitiesAPIURL = facilitiesAPIBaseURL + '/v1/facilities';
  const facilitiesAPIURLWithAirportCode = `${facilitiesAPIURL}?airportCodeIATA=${airportCode}`;
  const rawResponse = await fetch(facilitiesAPIURLWithAirportCode);

  if (!rawResponse.ok) {
    throw new Error(rawResponse.statusText);
  }

  const facilityData = await rawResponse.json();

  return facilityData;
};

export const fetchFacilitiesMetaData = async () => {

  const headers = new Headers({
      "cache-control": "max-age=172800"
  })
  const contactsResponse = await fetch('./content/global/contact/contacts.json', {
      headers: headers
  });
  const contactsData = await contactsResponse.json();

  const facilitiesResponse = await fetch('./content/global/contact/facilities.json', {
      headers: headers
  });
  const facilitiesData = await facilitiesResponse.json();

  const countriesResponse = await fetch('./content/global/contact/countries.json', {
      headers: headers
  });
  const countriesData = await countriesResponse.json();

  const managersResponse = await fetch('./content/global/contact/managers.json', {
      headers: headers
  });
  const managersData = await managersResponse.json();

  const interlineResponse = await fetch('./content/global/ship/interline-regions.json', {
      headers: headers
  });
  const interlineData = await interlineResponse.json();

  return {
    ...countriesData,
    ...contactsData,
    ...facilitiesData,
    ...managersData,
    ...interlineData
  };
};



// WEBPACK FOOTER //
// ./src/api/fetchFacilitiesData.js